// src/services/PostAttachment-service.js
import api from "@/services/api";

export default {
  async getPostAttachments(attachmentId, config = {}) {
    return await api.get(`/posts/attachments/${attachmentId}`, config);
  },

  async uploadPostAttachment(postId, data) {
    return await api.post(`/posts/${postId}/attachments`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deletePostAttachment(attachmentId) {
    return await api.delete(`/posts/attachments/${attachmentId}`);
  },
};